import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import emptyFunction from 'react-utils/emptyFunction';
import Header from 'settings-ui-lib/components/Header';
import UserProfileTabs from 'settings-ui-nav/components/tab-groups/UserProfileTabs';
import SettingsPage from 'settings-ui-nav/SettingsPage';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import FollowUpPopoverSection from '../components/section/FollowUpPopoverSection';
import TaskDefaultsSection from '../components/section/TaskDefaultsSection';
import TasksSettingsError from '../components/TasksSettingsError';
import TasksSettingsSaveFooter from '../components/TasksSettingsSaveFooter';
import { useFetchSettings } from '../hooks/useFetchSettings';
import { userGatesSelector } from '../selectors/AuthSelectors';
import { isErrorSelector, isLoadingSelector } from '../selectors/LoadingSelectors';
import { modifiedSettingsCountSelector } from '../selectors/SettingsSelectors';
import { tracker } from '../usage/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const pathname = `/settings/${PortalIdParser.get()}/user-preferences/tasks`;
const TaskSettingsContainer = () => {
  useFetchSettings();
  const stagedChangesCount = useSelector(modifiedSettingsCountSelector);
  const gates = useSelector(userGatesSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isError = useSelector(isErrorSelector);
  return /*#__PURE__*/_jsxs(SettingsPage, {
    onClickHandler: emptyFunction,
    pathname: pathname,
    track: tracker.track,
    settingsApp: "crm-settings-task-reminders",
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      "data-test-id": "task-settings-page"
    }), /*#__PURE__*/_jsx(Header, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.header.title"
      }),
      navigation: /*#__PURE__*/_jsx(UserProfileTabs, {
        gates: gates,
        pathname: pathname,
        hasStagedChanges: stagedChangesCount > 0
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.header.description"
      })
    }), isLoading ? null : isError ? /*#__PURE__*/_jsx(NavMarker, {
      name: "TASK_SETTINGS_ERROR",
      children: /*#__PURE__*/_jsx(TasksSettingsError, {})
    }) : /*#__PURE__*/_jsxs(NavMarker, {
      name: "TASK_SETTINGS_SUCCESS",
      children: [/*#__PURE__*/_jsx(TaskDefaultsSection, {}), /*#__PURE__*/_jsx(FollowUpPopoverSection, {})]
    }), /*#__PURE__*/_jsx(TasksSettingsSaveFooter, {})]
  });
};
export default TaskSettingsContainer;